import React, { useState } from "react";
import "./ToggleButton.css"; // Import the CSS file

const ToggleButton = ({ onToggle, isDarkMode }) => {

  const toggleTheme = () => {
    if (onToggle) onToggle(!isDarkMode);
  };

  return (
    <button
      className={`toggle-button ${isDarkMode ? "dark" : "light"}`}
      onClick={toggleTheme}
    >
      <div className="icon">{isDarkMode ? "🌙" : "☀️"}</div>
    </button>
  );
};

export default ToggleButton;
